export enum ApiRoutesAuditLog {
  AuditLogs = "admin/audit-logs",
  AuditAlerts = "admin/audit-alerts",
  Acknowledge = "acknowledge"
}

export enum AuditAlertsTab {
  Unreviewed = "unreviewed",
  All = "all"
}
